module.exports = __webpack_public_path__ + "static/model-scale.6400a4698fbab816aade6c9d5bd2c98b.svg";